import type { ReactNode } from 'react';

export interface BreedOverviewData {
  count: string;
  title: string;
  image: string;
  description: string;
  details: {
    label: string;
    value: string;
  }[];
  subscribeBtn: ReactNode;
}

export interface BreedOverviewProps extends BreedOverviewData {}
